export const translationsIds = [
  2016, 227, 228, 229, 5357, 5355, 5356, 4671, 11428, 10469, 1283, 232, 10870, 238, 2521, 236,
  11846, 11845, 10540, 10541, 10542, 10543, 11839, 10808, 10809, 10810, 723, 722, 1005, 11849,
  11850, 876, 11966, 878, 10886, 5456, 12601, 12688, 2698, 2894, 2114, 11496, 12829, 12815,
  13586, 13587, 13721, 13588, 13589, 1332, 13590, 13597, 13598, 13599, 13600, 13422, 13601, 13602,
  13603, 13604, 13605, 13606, 13607, 13237, 13608, 13609, 13610, 13610, 13611, 13612, 13613, 13614,
  13615, 13616, 2013, 609, 13617, 10436, 10437, 13618, 13619, 13620, 13621, 13622, 12150, 13623, 13624,
  13625, 13626, 13627, 13628, 13629, 13630, 13631, 13632, 13633, 13634, 13716, 12604, 13717, 4741,
  341, 13719, 13724, 9502, 10430, 10432, 9503, 13726, 1388, 13727, 13728, 13729, 13730, 13731, 9634,
  13733, 13734, 13735, 13732, 12917, 13736, 13635, 13636, 13737, 13269, 13270, 13738, 13645,
  13646, 13647, 13648, 11251, 11119, 13720, 10801, 10802, 10803, 11152, 13739, 11187, 13712, 13713,
  13740, 5821, 847, 691, 10682, 13741, 13742, 289, 291, 709, 708, 290, 292, 293, 609, 13617, 10436,
  10437, 13618, 13619, 13620, 13621, 13622, 12150, 13623, 13624, 13625, 13626, 276, 277, 278, 279, 280,
  13746, 13747, 13748, 13749, 13751, 13752, 13753, 13754, 2901, 13591, 13592, 13593, 13594, 1330,
  1331, 10473, 13596, 13299, 13755, 13756, 13757, 404, 13758, 13759, 13760, 10431, 6206, 13640,
  13641, 10569, 13642, 13643, 13644, 13637, 1135, 3764, 13766, 13772, 13773, 13769, 13768, 13774, 13770,
  13777, 13778, 13779, 13780, 13771, 13782, 13783, 13785, 13786, 13784, 11972, 707, 9560, 11486, 11487,
  327, 13790, 13639, 13792, 13791, 13789, 6226, 10966, 13794, 13793, 13795, 13796, 2438, 13797, 10997,
  13575, 13798, 13717, 1239, 2142, 11858, 11859, 4660, 2553, 1478, 1479, 3228, 3211, 1480, 1000, 3326,
  1470, 1471, 2173, 1488, 2142, 1485, 1475, 1473, 1816, 2482, 3351, 2471, 11383, 13799, 13800,
];

export const translationTextIds = [1637, 1638, 1639];
